import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-uikit/Typography";

interface ChartTitleProps {
  title: string;
  titleLabel?: string;
}

export const ChartTitle = ({ title, titleLabel }: ChartTitleProps) => (
  <div className="flex h-5 min-w-0 flex-1 items-center gap-1.5">
    <span className="truncate leading-none">
      <TippyV2 content={title} className="inline">
        <span>
          <Typography.LabelMd
            color="text-primary dark:text-white"
            weight="medium"
          >
            {title}
          </Typography.LabelMd>
        </span>
      </TippyV2>
    </span>
    {titleLabel && (
      <span className="h-5 whitespace-nowrap leading-none">
        <Typography.LabelXs color="text-default">
          {titleLabel}
        </Typography.LabelXs>
      </span>
    )}
  </div>
);

ChartTitle.displayName = "ChartTitle";
